
import actionStoreModule from '@/1-shifts-&-gigs/store/actionStoreModule'
import areaStoreModule from '@/1-shifts-&-gigs/store/areaStoreModule'
import gigStoreModule from '@/1-shifts-&-gigs/store/gigStoreModule'
import reportStoreModule from '@/1-shifts-&-gigs/store/reportStoreModule'
import requestStoreModule from '@/1-shifts-&-gigs/store/requestStoreModule'
import calendarStoreModule from '@/1-shifts-&-gigs/store/calendarStoreModule'
import reviewStoreModule from '@/1-shifts-&-gigs/store/reviewStoreModule'

import applicationsStoreModule from '@/2-hr/store/applicationsStoreModule'
import personelStoreModule from '@/2-hr/store/personelStoreModule'
import emailStoreModule from '@/2-hr/store/emailStoreModule'

import invoiceStoreModule from '@/3-pay-&-billing/store/invoiceStoreModule'
import pikapalkkaStoreModule from '@/3-pay-&-billing/store/pikapalkkaStoreModule'

import homeStoreModule from '../../0-dashboard/store/homeStoreModule'

// TODO also find this logic "if (!store.hasModule(" in hw-ui and possible move them here

const homeStore = {
  namespace: 'appHome',
  module: homeStoreModule,
}

const invoiceStore = {
  namespace: 'appInvoice',
  module: invoiceStoreModule
}

const actionCenterStore = {
  namespace: 'appActionCenter',
  module: actionStoreModule
}

const requestStore = {
  namespace: 'appRequest',
  module: requestStoreModule
}

const applicationsStore = {
  namespace: 'appApplications',
  module: applicationsStoreModule
}

const personelStore = {
  namespace: 'appPersonel',
  module: personelStoreModule
}

const emailStore = {
  namespace: 'appEmail',
  module: emailStoreModule
}

const gigStore = {
  namespace: 'appGigs',
  module: gigStoreModule
}

const calendarStore = {
  namespace: 'appCalendar',
  module: calendarStoreModule   
}

const areaStore = {
  namespace: 'appAreas',
  module: areaStoreModule
}

const reportStore = {
  namespace: 'appReport',
  module: reportStoreModule
}

const reviewStore = {
  namespace: 'appReview',
  module: reviewStoreModule
}

const quickShift = {
  namespace: 'appPikapalkka',
  module: pikapalkkaStoreModule
}

const modules = [
  {
    store: homeStore,
    apps: ['apps-dashboard-home']
  },
  // SHIFTS & GIGS
  {
    store: gigStore,
    apps: ['apps-gigs-management-list']
  },
  {
    store: calendarStore,
    apps: ['apps-shifts-calendar']
  },
  {
    store: areaStore,
    apps: ['apps-areas-management-list']
  },
  {
    store: requestStore,
    apps: ['apps-requests', 'apps-requests-view']
  },
  {
    store: reportStore,
    apps: ['apps-reports']
  },
  {
    store: reviewStore,
    apps: ['apps-reviews', 'apps-reviews-view']
  },
  {
    store: actionCenterStore,
    apps: [
      'apps-action-center', // SHIFTS & GIGS
      'apps-quick-shifts-pending' // PAY & BILLING // TODO is it correct?
    ]
  },

  // HR
  {
    store: applicationsStore,
    apps: ['apps-applications-list', 'apps-applications-view']
  },
  {
    store: personelStore,
    apps: ['apps-personels-list', 'apps-personels-view', 'apps-personels-edit',]
  },
  {
    store: emailStore,
    apps: ['apps-messages-list', 'apps-messages-edit', 'apps-questionnaire-list', 'apps-communications-list']
  },

  // PAY & BILLING
  {
    store: quickShift,
    apps: ['apps-quick-shifts-sent']
  },
  {
    store: invoiceStore,
    apps: ['apps-invoices-list', 'apps-invoices-edit', 'apps-invoices-view']
  },
]

const storeModules = modules.reduce((acc, module) => {
  module.apps.forEach(app => {
    acc[app] = module.store
  })
  return acc
}, {})

export default storeModules